import { render } from "./NotificationIndividualResponses.vue?vue&type=template&id=365b4b07&scoped=true&ts=true"
import script from "./NotificationIndividualResponses.vue?vue&type=script&lang=ts"
export * from "./NotificationIndividualResponses.vue?vue&type=script&lang=ts"

import "./NotificationIndividualResponses.vue?vue&type=style&index=0&id=365b4b07&scoped=true&lang=css"
import "./NotificationIndividualResponses.vue?vue&type=style&index=1&id=365b4b07&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365b4b07"]])

export default __exports__